// src/utils/numberUtils.js

/**
 * Rounds a number using HALF_UP strategy (traditional rounding).
 * Example: 2.345 -> 2.35
 *
 * @param {number} value - Number to round
 * @param {number} decimals - Decimal places (default is 2)
 * @returns {number}
 */
export function roundHalfUp(value, decimals = 2) {
  if (typeof value !== 'number') value = parseFloat(value);
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor + Number.EPSILON) / factor;
}
